<template>
    <div v-if="downloadURL">
        <div class="downloadTop pt-3 pb-1 px-4 text-end">
            <div class="container">
                <K2Icon link="true" name="file_download" :color="uiVariable.color.textLight" @onclick="downloadFile()" class="me-3"/>
                <K2Icon link="true" name="print" :color="uiVariable.color.textLight" @onclick="printPdf()"/>
            </div>
        </div>
        <div class="container">
            <!--<pdf class="media-file-image" -->
            <!--:src="downloadURL" style="max-width: 100%; overflow: auto;"></pdf>-->
            <K2PdfEmbed :source="downloadURL"/>
        </div>
    </div>
</template>
<script>
  import K2Icon from "../../uiComponents/k2Icon/k2MAIcon";
  import "./downloadDisplay.scss";
  import uiVariable from "../../config/uiVariable";
  import K2PdfEmbed from "../../uiComponents/k2Pdf/k2PdfEmbed";
  import { singleDownload } from "@/helper/utily";

  export default {
    name: "DownloadPreview",
    components: {
      K2PdfEmbed,
      K2Icon,
    },
    mounted() {
      if (this.$route.query) {
        this.downloadURL = this.$route.query.file;
        // this.studentID = this.$route.query.student;
        // this.invoiceID = this.$route.query.documentNo;
        this.fileName = this.$route.query.fileName;
      }
    },
    data() {
      return {
        downloadURL: "",
        // studentID: "",
        // invoiceID: "",
        uiVariable: uiVariable
      };
    },
    methods: {
      downloadFile() {
        singleDownload(this.downloadURL, this.fileName);
      },
      printPdf() {
        let iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.src = this.downloadURL;
        iframe.style.display = "none";
        iframe.onload = function() {
          setTimeout(function() {
            iframe.focus();
            iframe.contentWindow.print();
          }, 1);
        };

      }
    }
  };


</script>